import storeFeedback from "@/router/storeFeedback/storeFeedback";
import storeFeedbackReport from "@/router/storeFeedback/storeFeedbackReport";
import storeFeedbackReportQuestion from "@/router/storeFeedback/storeFeedbackReportQuestion";

export default [
	...storeFeedback,
	...storeFeedbackReport,
	...storeFeedbackReportQuestion
]
